<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{ hitType: string }>();

const abbreviations: Record<string, string> = {
  pep: 'PEP',
  sanctions: 'SAN',
  adversemedia: 'AM',
  crime: 'CRI',
  terrorism: 'TER',
  fitnessprobity: 'F&P',
  watchlist: 'WL',
};

const abbreviation = computed(() => abbreviations[props.hitType.toLowerCase()] ?? props.hitType);
</script>

<template>
  <span
    class="inline-flex w-fit items-center rounded bg-gray-100 px-1.5 py-0.5 text-[11px] font-semibold text-gray-700"
  >
    {{ abbreviation }}
  </span>
</template>
